/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * VSD API
 * API for the Victim Services Directory (VSD) application
 * OpenAPI spec version: v1
 */
import type {
  HttpResponse as AngularHttpResponse,
  HttpContext,
  HttpEvent,
  HttpHeaders,
  HttpParams
} from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

type HttpClientOptions = {
  headers?:
    | HttpHeaders
    | {
        [header: string]: string | string[];
      };
  context?: HttpContext;
  observe?: any;
  params?:
    | HttpParams
    | {
        [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
      };
  reportProgress?: boolean;
  responseType?: any;
  withCredentials?: boolean;
};

@Injectable({ providedIn: 'root' })
export class ConfigurationService {
  constructor(private http: HttpClient) {}
  getApiConfiguration<TData = void>(
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
  getApiConfiguration<TData = void>(
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
  getApiConfiguration<TData = void>(
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;
  getApiConfiguration<TData = void>(options?: HttpClientOptions): Observable<TData> {
    return this.http.get<TData>(`/cvapwebform/api/Configuration`, options);
  }
  getApiConfigurationKeycloak<TData = void>(
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
  getApiConfigurationKeycloak<TData = void>(
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
  getApiConfigurationKeycloak<TData = void>(
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;
  getApiConfigurationKeycloak<TData = void>(options?: HttpClientOptions): Observable<TData> {
    return this.http.get<TData>(`/cvapwebform/api/Configuration/keycloak`, options);
  }
}

export type GetApiConfigurationClientResult = NonNullable<void>;
export type GetApiConfigurationKeycloakClientResult = NonNullable<void>;
